
import { computed, defineComponent } from 'vue'
import { HOT_WINDOWS_ICONS } from '../icons'

/**
 * Иконка макета. Размер и толщину линии задают стили виджета по месту
 * (`.btn svg`, `.task-icon svg`…), как в макете, поэтому здесь их нет.
 */
export default defineComponent({
    name: 'HwIcon',
    props: {
        name: { type: String, required: true },
    },
    setup(props) {
        return { paths: computed(() => HOT_WINDOWS_ICONS[props.name] ?? '') }
    },
})
